import React from 'react';

export default function ArrowIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13">
      <g fill="none">
        <path d="M-6-5h24v24H-6z" />
        <path
          fill="#B6C1CD"
          d="M10.177 7.93L6.773 4.469l.689-.701L12 8.384 7.462 13l-.69-.701 3.32-3.377H0V0h.975v7.93z"
        />
      </g>
    </svg>
  );
}
